import { render, staticRenderFns } from "./TransferTypeDropdown.vue?vue&type=template&id=08e0774f"
import script from "./TransferTypeDropdown.js?vue&type=script&lang=js&external"
export * from "./TransferTypeDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports